var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0222 16L9.17778 10.1556C8.73333 10.5407 8.21512 10.8407 7.62313 11.0556C7.03115 11.2704 6.40122 11.3778 5.73333 11.3778C4.13093 11.3778 2.77478 10.8222 1.66487 9.71111C0.554956 8.6 0 7.25926 0 5.68889C0 4.11852 0.555556 2.77778 1.66667 1.66667C2.77778 0.555556 4.12222 0 5.7 0C7.27778 0 8.61852 0.555556 9.72222 1.66667C10.8259 2.77778 11.3778 4.11963 11.3778 5.69222C11.3778 6.32704 11.2741 6.94074 11.0667 7.53333C10.8593 8.12593 10.5481 8.68148 10.1333 9.2L16 15.0222L15.0222 16ZM5.71111 10.0444C6.91481 10.0444 7.93796 9.61852 8.78056 8.76667C9.62315 7.91481 10.0444 6.88889 10.0444 5.68889C10.0444 4.48889 9.62315 3.46296 8.78056 2.61111C7.93796 1.75926 6.91481 1.33333 5.71111 1.33333C4.49507 1.33333 3.46142 1.75926 2.61018 2.61111C1.75895 3.46296 1.33333 4.48889 1.33333 5.68889C1.33333 6.88889 1.75895 7.91481 2.61018 8.76667C3.46142 9.61852 4.49507 10.0444 5.71111 10.0444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon2);
export default __webpack_public_path__ + "static/media/searchicon2.0b421d65ec9d281835e4d0154e4b99a6.svg";
export { ForwardRef as ReactComponent };